<template>
  <div>
    <b-table-simple class="export-table m-0" borderless outlined style="border-bottom: 0 !important;">
      <b-thead>
        <b-tr class="title-row">
          <b-th colspan="4">{{ lodash.startCase($t('unloads.singular')) }}</b-th>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('drivers.singular')) }}</b-td>
          <b-td class="text-gray" style="width: 200px">: {{ driverLabel }}</b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.shows.date')) }}</b-td>
          <b-td class="text-gray">: {{ date }}</b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('vehicles.singular')) }}</b-td>
          <b-td class="text-gray" style="width: 175px">: {{ vehicleLabel }}</b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('factories.singular')) }}</b-td>
          <b-td class="text-gray">: {{ buyerName }}</b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px"></b-td>
          <b-td style="width: 175px"></b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.address')) }}</b-td>
          <b-td class="text-gray">: {{ address }}</b-td>
        </b-tr>
      </b-thead>
    </b-table-simple>
    <b-table-simple class="export-table" borderless outlined style="border-top: 0 !important;">
      <b-thead>
        <b-tr>
          <b-th rowspan="2">No</b-th>
          <b-th rowspan="2">{{ lodash.startCase($t('products.singular')) }}</b-th>
          <b-th colspan="2" style="text-align: center">{{ `${$t('purchase_orders.singular')}` }}</b-th>
          <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('unloads.singular')) }}</b-th>
          <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.performance')) }}</b-th>
          <b-th rowspan="2">{{ lodash.startCase($t('sale_notes.resumes.quality')) }}</b-th>
          <b-th rowspan="2" style="text-align: right">{{ `${lodash.startCase($t('sale_notes.resumes.price'))} (/${$t('sale_notes.resumes.kg')})` }}</b-th>
          <b-th rowspan="2" style="text-align: right; width: 175px">{{ lodash.startCase($t('sale_notes.resumes.amount'))}}</b-th>
        </b-tr>
        <b-tr>
          <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
          <b-th style="text-align: center">{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}</b-th>
          <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
          <b-th style="text-align: center">{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}</b-th>
          <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
          <b-th style="text-align: center">{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('sale_notes.resumes.kg')})` }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, index) in tableItems" :key="index">
          <b-td v-if="item._index_rowspan" :rowspan="item._index_rowspan">{{ item._index }}</b-td>
          <b-td v-if="item.trip_rowspan" :rowspan="item.trip_rowspan">
            {{ $t(`product_categories.${item.product_name}`) + ` ${item.service_fee}` }}
          </b-td>
          <b-td v-if="item.trip_rowspan" :rowspan="item.trip_rowspan" class="text-center">
            {{ decimalFormatter(item.trip_size) }}
          </b-td>
          <b-td v-if="item.trip_rowspan" :rowspan="item.trip_rowspan" class="text-center">
            {{ decimalFormatter(item.trip_quantity) }}
          </b-td>
          <b-td v-if="item.sale_rowspan" :rowspan="item.sale_rowspan" class="text-center">
            {{ decimalFormatter(item.sale_size) }}
          </b-td>
          <b-td v-if="item.sale_rowspan" :rowspan="item.sale_rowspan" class="text-center">
            {{ decimalFormatter(item.sale_quantity) }}
          </b-td>
          <b-td class="text-center"
                :class="item.size_performance_badge_variant === 'success' ? 'text-success' : 'text-danger'">
            {{ percentageFormatter(item.size_performance) }}
          </b-td>
          <b-td
              v-if="item.quantity_performance_rowspan"
              :rowspan="item.quantity_performance_rowspan"
              class="text-center"
              :class="item.quantity_performance_badge_variant === 'success' ? 'text-success' : 'text-danger'"
          >
            {{ percentageFormatter(item.quantity_performance) }}
          </b-td>
          <b-td v-if="item.sale_rowspan" :rowspan="item.sale_rowspan">
            {{ qualityFormatter(item.quality) }}
          </b-td>
          <b-td v-if="item.sale_rowspan" :rowspan="item.sale_rowspan" style="text-align: right">
            {{ currencyFormatter(item.unit_price) }}
          </b-td>
          <b-td v-if="item.sale_rowspan" :rowspan="item.sale_rowspan" style="text-align: right">
            {{ currencyFormatter(item.total_price) }}
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot v-if="exportItems.includes('unload') && exportItems.includes('balance')">
        <b-tr>
          <b-td></b-td>
          <b-td colspan="2"><b>{{ lodash.startCase($t('sale_notes.resumes.sub_total_sales')) }}</b></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td :class="{'text-center': true,'text-success': totalBiomass > 0, 'text-danger': totalBiomass < 0}"
          ><b>{{ `${decimalFormatter(totalBiomass)} ${lodash.startCase($t('units.kg'))}` }}</b></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td
              :class="{'text-success': totalPrice > 0, 'text-danger': totalPrice < 0}"
              style="text-align: right"
          ><b>{{ currencyFormatter(totalPrice) }}</b></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import {round} from "lodash";

export default {
  name: 'unload',
  props: {
    activeTab: {type: String, default: 'admin'},
    exportItems: {type: Array, default() { return [] }},
    purchaseOrders: {type: Array, default: function () { return {} }},
    value: {type: Object, default: function () { return [] }},
  },
  data() {
    return {
      tableNumber: 0,
    }
  },
  computed: {
    driverLabel() {
      let {
        trip: {
          driver: { name, phone_number },
        },
      } = this.value

      return `${name} (${phone_number})`
    },
    vehicleLabel() {
      let {
        trip: {
          vehicle: { type, license_plate },
        },
      } = this.value

      return `${this.lodash.startCase(this.$t(`vehicles.vehicle_types.${type}`))} (${license_plate})`
    },
    factoryName() {
      return this.value?.customer?.name || '-'
    },
    date() {
      if (!this.value?.ordered_at) return '-'
      return this.$moment.utc(this.value.ordered_at).local().format('DD MMMM YYYY')
    },
    orderId() {
      return this.value?.order_id || '-'
    },
    buyerName() {
      let { customer: { name } } = this.value
      return name
    },
    accelerationFee() {
      let accelerations = this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'biaya percepatan')
      return -accelerations.reduce((carry, { total }) => carry + total, 0)
    },
    address() {
      let customerAddress = this.value.customer?.addresses.find(({type}) => type === (this.value.is_unload_order ? 'processing' : 'brs'))
      let {region_full_name, address} = customerAddress ?? {}
      let result = address

      if (region_full_name) result = `${region_full_name}, ${result}`

      return result
    },
    otherFee() {
      let results = this.value?.sale_additional_items?.filter(({ name }) => !['pph 22', 'biaya percepatan'].includes(name.toLowerCase()) )
      return -results.reduce((carry, { total }) => carry + total, 0)
    },
    pph() {
      let results = this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'pph 22')
      return -results.reduce((carry, { total }) => carry + total, 0)
    },
    productServiceNames() {
      let names = this.purchaseOrders?.map(({product: {name}}) => name)
      if (!names.length) return '-'
      return this.lodash.uniq(names).join(', ')
    },
    subTotal() {
      return this.value?.sale_items?.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    },
    tableItems() {
      const saleItems = this.value?.sale_items ?? [];
      const getMinTripItemId = (saleItem) => {
        if (!saleItem?.trip_items?.length) return Number.POSITIVE_INFINITY;
        return saleItem.trip_items.reduce((minId, tripItem) => {
          const id = Number(tripItem?.id);
          if (!Number.isFinite(id)) return minId;
          return Math.min(minId, id);
        }, Number.POSITIVE_INFINITY);
      };
      const sortedSaleItems = [...saleItems].sort((a, b) => getMinTripItemId(a) - getMinTripItemId(b));
      let vm = this
      let formattedItems = [];
      let formattedIndex = 1;
      let partialTripItemIds = []

      for (let i = 0; i < sortedSaleItems.length; i++) {
        let item = sortedSaleItems[i];
        let sameTripItemCount = vm.value.sale_items.reduce((acc, curr) => acc + curr.trip_items.filter(tripItem => tripItem.id === item.trip_items[0].id).length, 0)
        item.is_merge_item = item.trip_items.length > 1
        item.is_partial_item = sameTripItemCount > 1
        item.is_single_item = !item.is_merge_item && !item.is_partial_item

        if (item.is_merge_item) {
          let totalTripItemQuantity = item.trip_items.reduce((acc, curr) => acc + curr.quantity, 0)

          item.trip_items.forEach((tripItem, index) => {
            let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
            let quantityPerformance = round((item.quantity - totalTripItemQuantity) / totalTripItemQuantity, 4)
            let saleRowspan = index === 0 ? item.trip_items.length : 0
            formattedItems.push({
              product_name: tripItem.product_code,
              service_fee: tripItem.purchase_order.service_fee,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: tripItem.size * 0.9,
              estimated_quantity: tripItem.quantity * 1.12,
              trip_rowspan: 1,
              sale_size: item.size,
              sale_quantity: item.quantity,
              quality: item.quality,
              unit_price: item.unit_price,
              total_price: item.total_price,
              size_performance: sizePerformance,
              size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance: quantityPerformance,
              quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance_rowspan: saleRowspan,
              sale_rowspan: saleRowspan,
              _index: formattedIndex,
              _index_rowspan: saleRowspan,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
            if (saleRowspan > 0) {
              formattedIndex++
            }
          })
        } else if (item.is_partial_item) {
          if (partialTripItemIds.includes(item.trip_items[0].id)) {
            continue
          }
          let tripItem = item.trip_items[0]
          let filteredSaleItems = this.value?.sale_items?.filter(saleItem => saleItem.trip_items[0].id === tripItem.id)
          let totalFilteredSaleItemsQuantity = filteredSaleItems.reduce((acc, curr) => acc + curr.quantity, 0)
          let tripRowspan = filteredSaleItems.length
          let quantityPerformance = round((totalFilteredSaleItemsQuantity - tripItem.quantity) / tripItem.quantity, 4)
          partialTripItemIds.push(tripItem.id)

          filteredSaleItems.forEach((saleItem, index) => {
            let sizePerformance = round((tripItem.size - saleItem.size) / tripItem.size, 4)
            formattedItems.push({
              product_name: tripItem.product_code,
              service_fee: tripItem.purchase_order.service_fee,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: tripItem.size * 0.9,
              estimated_quantity: tripItem.quantity * 1.12,
              trip_rowspan: index === 0 ? tripRowspan : 0,
              sale_size: saleItem.size,
              sale_quantity: saleItem.quantity,
              quality: saleItem.quality,
              unit_price: saleItem.unit_price,
              total_price: saleItem.total_price,
              size_performance: sizePerformance,
              size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance: quantityPerformance,
              quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
              quantity_performance_rowspan: index === 0 ? tripRowspan : 0,
              sale_rowspan: 1,
              _index: formattedIndex,
              _index_rowspan: index === 0 ? tripRowspan : 0,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
          })
          formattedIndex++
        } else if (item.is_single_item) {
          let tripItem = item.trip_items[0]
          let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
          let quantityPerformance = round((item.quantity - tripItem.quantity) / tripItem.quantity, 4)

          formattedItems.push({
            product_name: tripItem.product_code,
            service_fee: tripItem.purchase_order.service_fee,
            trip_size: tripItem.size,
            trip_quantity: tripItem.quantity,
            estimated_size: tripItem.size * 0.9,
            estimated_quantity: tripItem.quantity * 1.12,
            trip_rowspan: 1,
            sale_size: item.size,
            sale_quantity: item.quantity,
            quality: item.quality,
            unit_price: item.unit_price,
            total_price: item.total_price,
            size_performance: sizePerformance,
            size_performance_badge_variant: sizePerformance >= 0.05 ? 'success' : 'danger',
            quantity_performance: quantityPerformance,
            quantity_performance_badge_variant: quantityPerformance >= 0.05 ? 'success' : 'danger',
            quantity_performance_rowspan: 1,
            sale_rowspan: 1,
            _index: formattedIndex,
            _index_rowspan: 1,
            _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
          })
          formattedIndex++
        }
      }

      return formattedItems
    },
    total() {
      if (this.activeTab.toLowerCase() === 'admin') return this.value?.total ?? 0
      return this.subTotal - this.pph
    },
    totalBiomass() {
      return this.value?.sale_items?.reduce((carry, { quantity }) => carry + quantity, 0) ?? 0
    },
    totalPrice() {
      return this.subTotal
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    },
    percentageFormatter(value) {
      return `${this.$numeral(value).format('0,0.[00]%')}`
    }
  }
}
</script>

<style lang="scss" scoped>
.resume-table {
  th,td {
    vertical-align: middle;
  }
}
.resume-info {
  margin: 0;
  th, td {
    padding: 4px 8px;
  }
}
</style>
